"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpacingStyles = void 0;
var _useInternalSpacingStyles = require("./internal/useInternalSpacingStyles");
const useSpacingStyles = ({
  spacing,
  spacingBottom,
  spacingEnd,
  spacingHorizontal,
  spacingStart,
  spacingTop,
  spacingVertical
}) => {
  return (0, _useInternalSpacingStyles.useInternalSpacingStyles)({
    all: spacing,
    bottom: spacingBottom,
    end: spacingEnd,
    horizontal: spacingHorizontal,
    start: spacingStart,
    top: spacingTop,
    vertical: spacingVertical
  });
};
exports.useSpacingStyles = useSpacingStyles;